export let isNumeric = (text) => {

  let newText = '';
  let numbers = '0123456789';

  for (let val of text) {
      if (numbers.indexOf(val) > -1) {
          newText = newText + val;
      }else {
      }
  }

  return newText;
};
export let isAlphabetic = (inputString) => {
  var alphabeticRegex = /^[A-Za-z]+$/;
  return alphabeticRegex.test(inputString);
}
export let isEmail = (email) => {
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};
  
export let PostalCode = (inputString) => {
  var PostalCodeRegex =/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i; 
  return PostalCodeRegex.test(inputString);
}